var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98:3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1667 4.31297H35.9375V1.43797C35.9378 1.05672 35.7865 0.690987 35.5171 0.421224C35.2477 0.15146 34.8822 -0.000233774 34.501 -0.00048794C34.1197 -0.000742106 33.754 0.150465 33.4842 0.419868C33.2144 0.689272 33.0628 1.0548 33.0625 1.43605V4.31297H24.4375V1.43797C24.4376 1.2492 24.4006 1.06224 24.3284 0.88779C24.2563 0.713336 24.1505 0.554797 24.0171 0.421224C23.8837 0.28765 23.7253 0.181659 23.551 0.109302C23.3766 0.0369445 23.1897 -0.000362111 23.001 -0.000487961C22.6197 -0.000742127 22.254 0.150465 21.9842 0.419868C21.7144 0.689272 21.5628 1.0548 21.5625 1.43605V4.31297H12.9375V1.43797C12.9376 1.2492 12.9006 1.06224 12.8284 0.88779C12.7563 0.713336 12.6505 0.554797 12.5171 0.421224C12.3837 0.28765 12.2254 0.181659 12.051 0.109302C11.8766 0.0369445 11.6897 -0.000362111 11.501 -0.000487961C11.1197 -0.000742127 10.754 0.150465 10.4842 0.419868C10.2144 0.689272 10.0628 1.0548 10.0625 1.43605V4.31297H3.83333C2.817 4.31297 1.84227 4.71657 1.12343 5.43505C0.4046 6.15352 0.000508166 7.12806 0 8.14439V42.1652C0 43.1819 0.403868 44.1569 1.12276 44.8758C1.84165 45.5947 2.81667 45.9986 3.83333 45.9986H42.1667C43.1833 45.9986 44.1584 45.5947 44.8772 44.8758C45.5961 44.1569 46 43.1819 46 42.1652V8.14439C45.9995 7.12806 45.5954 6.15352 44.8766 5.43505C44.1577 4.71657 43.183 4.31297 42.1667 4.31297ZM43.125 42.1671C43.125 42.421 43.0243 42.6644 42.845 42.8441C42.6657 43.0238 42.4224 43.125 42.1686 43.1255H3.83333C3.57917 43.1255 3.33541 43.0245 3.15569 42.8448C2.97597 42.6651 2.875 42.4213 2.875 42.1671V8.1463C2.87551 7.89247 2.9767 7.64921 3.15637 7.4699C3.33603 7.29059 3.5795 7.18989 3.83333 7.18989H10.0625V10.0649C10.0622 10.4461 10.2135 10.8119 10.4829 11.0816C10.7523 11.3514 11.1178 11.5031 11.499 11.5033C11.8803 11.5036 12.246 11.3524 12.5158 11.083C12.7856 10.8136 12.9372 10.4481 12.9375 10.0668V7.18989H21.5625V10.0649C21.5622 10.4461 21.7135 10.8119 21.9829 11.0816C22.2523 11.3514 22.6178 11.5031 22.999 11.5033C23.3803 11.5036 23.746 11.3524 24.0158 11.083C24.2856 10.8136 24.4372 10.4481 24.4375 10.0668V7.18989H33.0625V10.0649C33.0622 10.4461 33.2135 10.8119 33.4829 11.0816C33.7523 11.3514 34.1178 11.5031 34.499 11.5033C34.8803 11.5036 35.246 11.3524 35.5158 11.083C35.7855 10.8136 35.9372 10.4481 35.9375 10.0668V7.18989H42.1667C42.4202 7.19039 42.6631 7.29132 42.8424 7.47057C43.0216 7.64983 43.1226 7.8928 43.1231 8.1463L43.125 42.1671Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 17.25H15.8125V21.5625H10.0625V17.25Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 24.4375H15.8125V28.75H10.0625V24.4375Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 31.625H15.8125V35.9375H10.0625V31.625Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 31.625H25.875V35.9375H20.125V31.625Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 24.4375H25.875V28.75H20.125V24.4375Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.125 17.25H25.875V21.5625H20.125V17.25Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1875 31.625H35.9375V35.9375H30.1875V31.625Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1875 24.4375H35.9375V28.75H30.1875V24.4375Z",
    fill: "#27273D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1875 17.25H35.9375V21.5625H30.1875V17.25Z",
    fill: "#27273D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98:3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/calender-icon.538a4b27.svg";
export { ForwardRef as ReactComponent };